import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditRoleGroupPage } from './edit-role-group.page';

const routes: Routes = [
  {
    path: '',
    component: EditRoleGroupPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditRoleGroupPageRoutingModule {}
